import { classes } from '../const';

const { isActive } = classes;

// const $$accordions = $('.js-accordion');

const accordions = () => {
  const $$accordions = $('.js-accordion');
  $$accordions.each((i, el) => {
    const $$btns = $(el).find('.js-acc-btn');
    $$btns.each((j, btn) => {
      const $targetContent = $(btn).closest('.js-acc-item').find('.js-acc-content');

      if (!$targetContent.hasClass('has_event')) {
        $targetContent.addClass('has_event')
        $(btn).click(event => {
          event.preventDefault();
          $(btn).toggleClass(isActive);

          if ($(btn).hasClass(isActive)) {
            $targetContent.slideDown(500);
          } else {
            $targetContent.slideUp(500);
          }

        });
      }


    });
  });
};

export default accordions;
